import * as React from 'react';
import { compose } from 'recompose';
import { InjectedFormProps } from 'redux-form';
import { reduxForm } from 'redux-form';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';

import * as actions from './actions';

import PATHS from '../../constants/paths';

import AuthForm from './AuthForm';

import IMPComponent from '../../components/interfaces/IMPComponent';

import { makeGetGlobalAuthFormErrors } from './selectors';
import withActionsDispatch from '../../hocs/withActionsDispatch';
import { authClearGlobalFormErrors, authSubmitSignUpForm } from './actions';

interface ISignUpFormProps extends IMPComponent {
  submitSignUpForm: typeof authSubmitSignUpForm;
  globalErrors: string[];
}

const MESSAGE_BASE = 'containers.Auth.SignUpForm';

export const SIGN_UP_FORM = 'signUpForm';

class SignUpForm extends React.Component<ISignUpFormProps & InjectedIntlProps & InjectedFormProps> {
  public render() {
    const { handleSubmit, intl, ...formProps } = this.props;

    return (
      <AuthForm
        linkPath={PATHS.AUTH.SIGN_IN}
        messageBase={MESSAGE_BASE}
        intl={intl}
        onSubmit={handleSubmit(this.onSubmit)}
        {...(formProps as any)}
      />
    );
  }

  private onSubmit = (values: any) => {
    const { submitSignUpForm } = this.props;

    submitSignUpForm();
  };
}

const enhance = compose<ISignUpFormProps & InjectedIntlProps, ISignUpFormProps>(
  injectIntl,
  reduxForm({
    form: SIGN_UP_FORM,
  }),
  connect(
    state => {
      return {
        globalErrors: makeGetGlobalAuthFormErrors(SIGN_UP_FORM)(state),
      };
    },
    {
      submitSignUpForm: actions.authSubmitSignUpForm,
    },
  ),
  withActionsDispatch({
    onMount: [],
    onUnmount: [authClearGlobalFormErrors(SIGN_UP_FORM)],
  }),
);
export default enhance(SignUpForm);



// WEBPACK FOOTER //
// ./src/containers/Auth/SignUpForm.tsx